import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function MarketsFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Expand your market reach with mulitple currencies'
            subHeader='Manage multiple currencies for international sales and adapt pricing to local needs.'
            bullets={[
                'Support your global growth by adding multiple currencies, making it easier to manage sales in different regions.',
                'Ensure accurate pricing for every market, so you can provide customers with the right quotes and build trust.',
                'Unlock unlimited markets with the Enterprise plan, allowing you to tailor your pricing strategy for every territory you serve.',
            ]}
            feature='markets'
        />
    );
}
